import fetch from 'isomorphic-fetch';
import { IS_DEBUG } from '../helpers/helper';

export default class ApiBase {
  static objectToQueryString(obj) {
    if (!obj) {
      return null;
    }

    const queryArray = Object.keys(obj).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    return queryArray.join('&');
  }

  static async get(url, params) {
    const searchParams = ApiBase.objectToQueryString(params);
    const urlWithParams = searchParams ? `${url}?${searchParams}` : url;
    return await ApiBase.requestBase(urlWithParams, 'GET');
  }

  static async post(url, params) {
    return await ApiBase.requestBase(url, 'POST', params);
  }

  static async patch(url, params) {
    return await ApiBase.requestBase(url, 'PATCH', params);
  }

  static async put(url, params) {
    return await ApiBase.requestBase(url, 'PUT', params);
  }

  static async delete(url, params) {
    return await ApiBase.requestBase(url, 'DELETE', params);
  }

  static getAllUrlParams(url) {
    if (url.split('?').length === 1) {
      return {};
    }
    const queryString = url.split('?')[1];
    if (!queryString) {
      return {};
    }
    const results = {};
    const params = queryString.split('#')[0].split('&');
    for (let i = 0; i < params.length; i += 1) {
      const a = params[i].split('=');
      let name = a[0];
      let value = typeof (a[1]) === 'undefined' ? true : a[1];
      name = name.toLowerCase();
      if (typeof value === 'string') value = value.toLowerCase();
      if (name.match(/\[(\d+)?\]$/)) {
        const key = name.replace(/\[(\d+)?\]/, '');
        if (!results[key]) results[key] = [];
        if (name.match(/\[\d+\]$/)) {
          const index = /\[(\d+)\]/.exec(name)[1];
          results[key][index] = value;
        } else {
          results[key].push(value);
        }
      } else if (!results[name]) {
        results[name] = value;
      } else if (results[name] && typeof results[name] === 'string') {
        results[name] = [results[name]];
        results[name].push(value);
      } else {
        results[name].push(value);
      }
    }
    return results;
  }

  static async requestBase(url, method, body) {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
    };
    const params = {
      headers,
      method,
    };

    if (body) {
      params.body = JSON.stringify(body);
    }
    const response = await fetch(`${url}`, params);
    if (IS_DEBUG) {
      console.group(`%capi %c[${params.method}] %c${url}`, ...['color: grey; font-weight: lighter;'], 'color: orange;', 'color: white');
      if (params.method === 'GET') {
        console.log('%cparams', ...['color: grey; font-weight: lighter;'], ApiBase.getAllUrlParams(url));
      } else if (body !== undefined) {
        console.log('%cparams', ...['color: grey; font-weight: lighter;'], body);
      }
    }

    const json = await response.json().catch((/* err */) => ({}));
    const error = ApiBase.statusToError(response, json);
    if (error) {
      if (IS_DEBUG) {
        console.groupEnd();
      }
      throw error;
    }
    if (IS_DEBUG) {
      console.log('%cresponse', ...['color: grey; font-weight: lighter;'], json);
      console.groupEnd();
    }
    return json;
  }

  static statusToError(response, json) {
    if (ApiBase.isStatusSuccess(response.status)) {
      return null;
    }
    return {
      response,
      json,
      message: `[${response.status}]${response.statusText}: ${json.error}`,
    };
  }

  static isStatusSuccess(status) {
    return Math.floor(status / 100) === 2;
  }
}
